import React from 'react';
import { useTranslation } from 'react-i18next';
import ServiceCard, { ServiceCardProps } from '../components/ServiceCard';
import Carousel from '../components/Carousel';

export const services: ServiceCardProps[] = [
  {
    id: 1,
    title: 'services.flights',
    description: 'services.flightsDesc',
    icon: 'fas fa-plane',
  },
  {
    id: 2,
    title: 'services.hotels',
    description: 'services.hotelsDesc',
    icon: 'fas fa-hotel',
  },
  {
    id: 3,
    title: 'services.transport',
    description: 'services.transportDesc',
    icon: 'fas fa-car',
  },
  {
    id: 4,
    title: 'services.consulting',
    description: 'services.consultingDesc',
    icon: 'fas fa-wand-magic-sparkles',
  },
  {
    id: 5,
    title: 'services.tours',
    description: 'services.toursDesc',
    icon: 'fas fa-book-atlas',
  },
  {
    id: 6,
    title: 'services.support',
    description: 'services.supportDesc',
    icon: 'fas fa-headset',
  },
];
const ServicesPage: React.FC = () => {
  const { t } = useTranslation();

  const carouselItems = services.map((service) => ({
    id: service.id,
    content: <ServiceCard service={service} />,
  }));

  return (
    <div className="bg-gradient-to-b from-gray-50 to-white py-12 md:py-20">
      <div className="container mx-auto px-4 md:px-6">
        <div className="container mx-auto px-6">
          {/* Mission & Vision Section - Reversed for RTL */}
          <div className={'flex flex-col md:flex-row items-center mb-12'}>
            {/* Image */}
            <div className="md:w-1/3 mx-0 md:mx-10 mb-10 md:mb-0">
              <img
                src="/assets/images/services2.png"
                alt={t('about.imageAlt')}
                className="w-full h-auto object-cover rounded-xl shadow-lg"
              />
            </div>
            <div>
              {/* Header Section */}
              <div className="mb-6">
                <h1 className="text-blue-700 font-bold mb-2">
                  {t('header.services')}
                </h1>
                <p className="text-2xl font-bold">
                  {t('home.servicesSubtitle')}
                </p>
              </div>

              {/* Lead Text Section */}
              <div className="md:w-2/3 text-black text-lg">
                <p className="text-base md:text-lg text-gray-700 leading-relaxed">
                  {t('services.description')}
                </p>
                <p className="text-base md:text-lg text-gray-700 leading-relaxed">
                  {t('services.textBlock1')}
                </p>
                <p className="text-base md:text-lg text-gray-700 leading-relaxed">
                  {t('services.textBlock2')}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Services Carousel */}
        <div className="relative px-4 md:px-12">
          <Carousel
            items={carouselItems}
            type="service"
            customNavigation={true}
          />
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;
